import { render, staticRenderFns } from "./buttonSelect.vue?vue&type=template&id=0706f4a4&scoped=true&"
import script from "./buttonSelect.vue?vue&type=script&lang=js&"
export * from "./buttonSelect.vue?vue&type=script&lang=js&"
import style0 from "./buttonSelect.vue?vue&type=style&index=0&id=0706f4a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0706f4a4",
  null
  
)

export default component.exports